/**
 * Измененная реализация библиотеки BX4 с возможностью отправлять события
 * при получении ответа от АПИ Битрикс24
 *
 * Запуск обработчиков при получение ответа реализован только для методов
 *  - selectUsers()
 *  - callBatch()
 *
 *  Для остальных методов оригинальной BX24 запуск обработчиков необходимо
 *  настраивать аналогично уже сделанным.
 *
 */
BX24.prototype = Object.create(window.BX24);

BX24.selectUsersInit = BX24.prototype.selectUsers;
BX24.selectUsers = function (callback) {
    callback = this.buildFullCallback(callback);
    this.prototype.selectUsersInit(callback);
};

BX24.callBatchInit = BX24.prototype.callBatch;
BX24.callBatch = function (calls, callback, bHaltOnError) {
    if (!callback) {
        callback = () => { };
    }
    if (!bHaltOnError) {
        bHaltOnError = false;
    }
    callback = this.buildFullCallback(callback);
    this.prototype.callBatchInit(calls, callback, bHaltOnError);
};

BX24.callMethodInit = BX24.prototype.callMethod;
BX24.callMethod = function (method, params, callback) {
    callback = this.buildFullCallback(callback);
    this.prototype.callMethodInit(method, params, callback);
};

BX24.receiverCallbacks = [];
BX24.addReceiverCallback = function (callback) {
    this.receiverCallbacks.push(callback);
};
BX24.buildFullCallback = function (callback) {
    let fullCallback = function (...args) {
        callback(...args);
        for (let callbackReceiver of BX24.receiverCallbacks) {
            setTimeout(callbackReceiver, 0);
        }
    };
    return fullCallback;
};
